import { Popover } from '@bambi/component-library/src/components/Popover/Popover';
import { InformationCircleIcon } from '@heroicons/react/20/solid';

import { PayerOrganizationRead } from 'src/common/external/bambi-api/bambiApi';

import PayerSettingDetails from './PayerSettingDetails';

export const PayerSettingsPopover = ({
  payer,
}: {
  payer: PayerOrganizationRead;
}) => (
  <Popover
    trigger={
      <div className="flex cursor-pointer items-center">
        <div>{payer.display_name}</div>
        <InformationCircleIcon className="ml-1 h-4 w-4" />
      </div>
    }
    content={<PayerSettingDetails payer={payer} />}
  />
);
